export default {
  newDesign: true,
  parameters: {
    landing_id: "UKQMine",
    segment: 3,
    date_start: 0,
    date_end: 6,
  },
  title: "Fun & Practical Programming Courses for Kids Aged 8–17 | Kodland",
  downtimeUrl: "https://www.kodland.org/",
  startPage: {
    title:
      "Answer a few quick questions to get access to your free trial lesson.",
    subtitle:
      "Your child will build their own game while learning how to turn screen time into valuable tech skills.",
    image: {
      url: "/welcome/uk_mine_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/uk_mine_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "🚀 Start the quiz",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title:
      "Thank you for your interest in Kodland. Our online courses are designed for children aged 8 to 17.",
    subtitle:
      'Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.<br>If you do have a laptop, please resubmit the form via this link <a target="_blank" href="https://mrqz.me/66c7170aca95fe0026c5a69c?roistat_visit=9376">this link</a>, or contact us at +447700182949💙',
  },
  customStopPages: {
    minAge: {
      title: "Thank you for trusting our educational platform!",
      subtitle:
        "We’re sorry for the inconvenience, but Kodland classes are designed for children aged 8 to 17. We hope to see you again in the future! 😊",
      image: "/welcome/quizV2/ageENGV2.png",
    },
    maxAge: {
      title: "Thank you for trusting our educational platform!",
      subtitle:
        "We’re sorry for the inconvenience, but Kodland classes are designed for children aged 8 to 17. We hope to see you again in the future! 😊",
      image: "/welcome/quizV2/ageENGV2.png",
    },
  },
  quizRotateBySteps: {
    1: {
      title: "What is your child’s age?",
      type: "age",
      button: "",
    },
    2: {
      question:
        "How much time does your child spend using electronic devices each day?",
      answers: ["😍 About 1 hour", "😊 2–3 hours", "🤭 More than 4 hours"],
    },
    3: {
      typeInfo: "noQuestions",
      subtitle:
        "While it is recommended that children limit their screen time to no more than 2 hours per day, many often exceed this amount. To support a healthy balance, we suggest combining entertainment with productive activities, such as lessons lasting 1 to 1.5 hours.<br>Our programs are thoughtfully designed to encourage this balance.",
      button: "A great choice!",
    },
    4: {
      question: "How would you describe your child’s personality?",
      subtitle: "(This helps us choose the best teaching style.)",
      answers: [
        "🐶 Energetic and talkative",
        "🌙 Dreamer and imaginative",
        "🤔 Still figuring out what they like",
        "😳 Shy",
        "🌱 Calm and prefers solo activities",
      ],
    },
    5: {
      question: "What matters most to you in a learning experience?",
      answers: [
        "🤝 Connecting with your child",
        "🚀 Seeing quick results",
        "🍎 Keeping them motivated and interested",
        "🛠 Gaining useful skills for the future",
        "😊 Friendly, supportive environment",
        "🖥 Having a dedicated learning platform",
      ],
    },
    6: {
      question: "How motivated is your child to learn?",
      answers: [
        "🔥 Very motivated",
        "🙂 Somewhat motivated",
        "😴 Not very motivated",
      ],
    },
    7: {
      question: "What would you like your child to gain from the course?",
      answers: [
        "🎮 Have fun while learning",
        "👨‍💻 Learn real tech skills",
        "🧠 Improve focus and discipline",
        "📱 Use screen time more productively",
        "🧩 Discover what they enjoy",
        "💬 Develop creativity and communication",
      ],
    },
    8: {
      question: "Does your child have access to a computer for studying?",
      answers: [
        "Yes, they have their own 💻",
        "Yes, but they share it 🖥️",
        {
          answer: "No, they don’t 🚫",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "Just one step left 🎉",
      typeInfo: "congrats",
      subtitle:
        "Unlock your child's creative potential in coding and digital creation!",
      button: "📅 Schedule a lesson",
    },
    10: {
      title: "Sign up for a free trial class",
      type: "one-page-contacts",
      subtitle:
        "Let’s get to know each other, find out what we will learn, and how the lessons will be conducted.",
      button: "👏 Great. The final step!",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      title: "Check out this information to complete the registration ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    13: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    14: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    },
  },
};
